import type {ChatActivityMessageParticipants, ChatMessage} from '../types';

export const appendGroupedParticipants = (
    previousMessage: ChatMessage,
    newMessage: ChatMessage,
): ChatActivityMessageParticipants[] | undefined => {
    if (previousMessage.groupedParticipants?.length) {
        return [
            ...previousMessage.groupedParticipants,
            {
                userId: newMessage.userId,
                isMe: newMessage.isMe,
                displayName: newMessage.displayName,
                timestamp: newMessage.timestamp,
            },
        ];
    }

    return [
        {
            userId: previousMessage.userId,
            displayName: previousMessage.displayName,
            isMe: previousMessage.isMe,
            timestamp: previousMessage.timestamp,
        },
        {
            userId: newMessage.userId,
            displayName: newMessage.displayName,
            isMe: newMessage.isMe,
            timestamp: newMessage.timestamp,
        },
    ];
};

export const buildGroupedActivityMessage = (
    previousMessage: ChatMessage,
    newMessage: ChatMessage,
): ChatMessage => ({
    ...newMessage,
    userId: undefined,
    displayName: '',
    groupedParticipants: appendGroupedParticipants(previousMessage, newMessage),
});
